import { render, staticRenderFns } from "./CardLabelsV2.vue?vue&type=template&id=13628244&scoped=true&"
import script from "./CardLabelsV2.vue?vue&type=script&lang=js&"
export * from "./CardLabelsV2.vue?vue&type=script&lang=js&"
import style0 from "./CardLabelsV2.vue?vue&type=style&index=0&id=13628244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13628244",
  null
  
)

export default component.exports